import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
// import { PageHeader } from '@excoleadershipui/pionweblib';
import { PageHeader } from '../../../components';
import { useDispatch } from 'react-redux';
// material ui
import { Grid } from '@mui/material'
// material icon
import CancelIcon from "@mui/icons-material/Cancel";
// components
import AssessmentTemplateDimension from './AssessmentTemplateDimension'
import AssessmentTemplateSection from './AssessmentTemplateSection'
import Layout from '../../../layout/Layout';

import { sectionRowSelect, rowSelect } from '../../../features/prepare_assessments/assessmentTemplateSectionSlice';

const ConfigureAssessmentTemplate = (props) => {

  const dispatch = useDispatch()

  useEffect(() => {
    try {

      dispatch(rowSelect({}));
      // this code is commented because if the user clicks on dimension level question and if he comes back he want 
      // to see the selected section that's why if any issue please uncomment this one
      // dispatch(sectionRowSelect({}));

    } catch (err) {
      
    }
  }, []);

  const location = useLocation();
console.log("location",location)
  return (
    <Layout>
      
      <Link
       aria-label="Cancel and return to prepare"
      to="/exco/prepare" state={{ 
        permissions: location?.state?.permissions,
        assessmentType:location?.state?.assessmentType,
        selectedCustValue: location?.state?.selectedCustValue,
        selectedAccountValue: location?.state?.selectedAccountValue
        }} >
        <CancelIcon  aria-hidden="true" color="red" sx={{ position: "absolute", right: 15, zIndex: 1 }} />
      </Link>
      <PageHeader variant="pageHeader" assessmentType={location?.state?.assessmentType}>

      </PageHeader>
      <Grid container spacing={2} mt-4>

        <Grid item xs={12} sm={12} md={6} >
          <AssessmentTemplateSection permissions={location?.state?.permissions}
          selectedCustValue= {location?.state?.selectedCustValue}
          selectedAccountValue= {location?.state?.selectedAccountValue}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} >
          <AssessmentTemplateDimension permissions={location?.state?.permissions}
          selectedCustValue= {location?.state?.selectedCustValue}
          selectedAccountValue= {location?.state?.selectedAccountValue}
          />
        </Grid>
      </Grid>
    </Layout>
  )
}

export default ConfigureAssessmentTemplate